'use client';

import { c as _c } from "react/compiler-runtime";
import { DataList } from '@morpho-org/ui-v6/client';
import { Skeleton } from '@morpho-org/ui-v6/server';
const ApyDataLineLoading = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <DataList.Line><Skeleton className="h-md w-[100%] rounded-[20px]" /></DataList.Line>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};

/** Mirrors `ApyDataList`: instant and 7D APY, then 30D and 90D. */
const ApyDataListPerformanceLoading = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <DataList.Column><ApyDataLineLoading /><ApyDataLineLoading /></DataList.Column>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <DataList.Root fullWidth={true}>{t0}<DataList.Column><ApyDataLineLoading /><ApyDataLineLoading /></DataList.Column></DataList.Root>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default ApyDataListPerformanceLoading;